import styled from "styled-components";

export const Paragraph = styled.p`
  font-size: 0.8rem;

  color: #4B5768;
`
